import {
  getConsultantInfo,
} from '../../request';

import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage } from "./ui";

//Загрузка информации об отчете
export const CONSULTANT_INFO_LOADING_START = "Consultant info loading start";
export const CONSULTANT_INFO_LOADED_SUCCESSFULLY = "Consultant info loaded successfully";
export const CONSULTANT_INFO_LOADING_FAILED = "Failure during consultant info load";


const startLoading = () => ({
  type: CONSULTANT_INFO_LOADING_START 
});

const loadSuccess = consultant => ({
  type: CONSULTANT_INFO_LOADED_SUCCESSFULLY,
  payload: {
    consultant: consultant || {}
  }
});

const loadFailure = () => ({
  type: CONSULTANT_INFO_LOADING_FAILED,
});

//ЗАГРУЗКА ИНФОРМАЦИИ О КОНСУЛЬТАНТЕ
export const getConsultantInfoAsync = id => { 
  return async (dispatch) => {
    dispatch(startLoading());
    await dispatch(checkAndRenewTokens());
    let consultant;
    const accessToken = localStorage.getItem("accessToken");
    try {
      consultant = await getConsultantInfo(accessToken, id);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке информации о консультанте!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(consultant));
  };
};
